import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1",attrs:{"data-cy":"autocomplete"}},[_c(VTextField,{attrs:{"solo":"","flat":"","clearable":"","hide-details":"","clear-icon":_vm.mdiClose,"prepend-inner-icon":_vm.mdiMagnify,"label":_vm.label,"loading":_vm.loading},model:{value:(_vm.q),callback:function ($$v) {_vm.q=$$v},expression:"q"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }